import {
  Button,
  DraggableWindowHeader,
  TextArea,
  usePasteOnlyEmail,
  useValidatedState,
} from "@hoylu/client-common";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { inviteUsers } from "../../state/user/user.actions";
import { cancelDashboardOption } from "../../state/workspaces/workspaces.actions";
import { Localized } from "../../strings";
import { emailRegex } from "../../utils/emailRegex";
import Styles from "./InviteUsersDialog.module.css";
import { Modal } from "./Modal";

const reg = /\s+/;

export const InviteUserDialog = () => {
  const dispatch = useDispatch();
  const strings = Localized.object("INVITE_USERS");
  const tClose = Localized.object("CLOSE_BUTTON");

  const ref = usePasteOnlyEmail(" ");
  const emailValidator = (emails: string[] | undefined) => {
    if (emails && !emails?.every((e) => !!e.match(emailRegex))) {
      return strings.ERR;
    }
  };

  const quantityValidator = (emails: string[] | undefined) => {
    if (emails && emails.length > 10) {
      return strings.ERR_QTY;
    }
  };

  const [emailList, setEmailList, emailListErr] = useValidatedState<string[]>(
    [],
    [emailValidator, quantityValidator],
  );
  const [emails, setEmails] = useState("");

  useEffect(() => {
    setEmailList(emails.split(reg).filter((e) => e));
  }, [emails]);

  const inviteUsersHandler = () => {
    dispatch(
      inviteUsers.request({
        emails: emailList,
        reason: "Invite to join Hoylu",
      }),
    );
    dispatch(cancelDashboardOption());
  };

  return (
    <Modal handleOutsideClick={() => dispatch(cancelDashboardOption())}>
      <DraggableWindowHeader
        close={tClose.CLOSE}
        onClose={() => dispatch(cancelDashboardOption())}
        title={strings.INVITE_USERS_HEADER}
      />
      <div className={Styles.inviteUsersDescription}>
        {strings.INVITE_USERS_DESCRIPTION}
      </div>
      <TextArea
        error={emailListErr}
        isFocus={true}
        label=""
        onChange={(value) => setEmails(value)}
        ref={ref}
        textareaHeight="12rem"
        toolTip={emailListErr ?? strings.HINT}
        value={emails}
      />
      <div className={Styles.footer}>
        <Button
          onClick={() => dispatch(cancelDashboardOption())}
          toolTip={strings.CANCEL}
          type="negative"
        >
          {strings.CANCEL}
        </Button>
        <Button
          disabled={emailList.length === 0 || !!emailListErr}
          onClick={() => inviteUsersHandler()}
          toolTip={strings.INVITE}
          type="primary"
        >
          {strings.INVITE}
        </Button>
      </div>
    </Modal>
  );
};
